import type { DatapointOptions, CustomDataMap, InternalDatapointOptions, INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT, } from "owa-analytics-types";
import type { AnalyticsCoreEventNames } from "owa-analytics-events";
import GreyErrorDatapoint from "../datapoints/GreyErrorDatapoint";
import { logDatapoint } from "./logDatapoint";
import type { MailboxInfo } from "owa-client-types";

export function logCoreGreyError(eventName: AnalyticsCoreEventNames, mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined, error?: Error, customData?: CustomDataMap, options?: DatapointOptions): Promise<void> {
    const logGreyErrorOptions: InternalDatapointOptions = { ...(options ? options : {}) };
    logGreyErrorOptions.isCore = true;
    
    return logDatapoint(new GreyErrorDatapoint(eventName, mailbox, error, customData, logGreyErrorOptions));
}
